/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantDeploymentDeletionSpec { 
    /**
     * Skip deleting shadow account resources during deactivation.
     */
    skip_resource_deletion?: boolean;
}

